import { HttpContextToken } from '@angular/common/http';

/**
 * Set on requests whose failures the caller handles itself — a public page
 * asking for an unpublished month should show its own empty state, not the
 * global error toast.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
